import { CalculatorRecommendations } from 'apps/SolarCalculator/components/CalculatorResult/CalculatorResult.types';

export interface RequestError {
  error: boolean;
  message?: string;
}

export interface RequestSubmit {
  submitting: boolean;
  error?: boolean;
  message?: string;
  validating?: boolean;
}

export type RequestAction =
  | { type: 'REQUEST_ERROR'; payload: RequestError }
  | { type: 'REQUEST_STATE'; payload: RequestSubmit }
  | { type: 'SET_RECOMMENDATION'; payload: CalculatorRecommendations };

export const setRequestError = (payload: RequestError): RequestAction => ({
  type: 'REQUEST_ERROR',
  payload
});
export const setRequestState = (payload: RequestSubmit): RequestAction => ({
  type: 'REQUEST_STATE',
  payload
});

export const setRecommendations = (payload: CalculatorRecommendations): RequestAction => ({
  type: 'SET_RECOMMENDATION',
  payload
});
